import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import ProductDetails from './components/ProductDetails/ProductDetails'
import { ProductListProvider } from './context/ProductListContext'
import { ProductProvider } from './context/ProductContext'
import { PermissionProvider } from './context/PermissionContext'
import AdminPage from './components/AdminPage/AdminPage'
import { LoadingProvider } from './context/LoadingContext'
import { PartNumberProvider } from './context/PartNumberContext'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />
  },
  {
    path: '/products/:id',
    element: (
      <PartNumberProvider>
        <ProductDetails />
      </PartNumberProvider>
    )
  },
  {
    path: '/admin',
    element: <AdminPage />
  }
])

const rootElement = document.getElementById('root')
if (rootElement != null) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    // <React.StrictMode>
    <ProductListProvider>
      <ProductProvider>
        <PermissionProvider>
          <LoadingProvider>
            <RouterProvider router={router} />
          </LoadingProvider>
        </PermissionProvider>
      </ProductProvider>
    </ProductListProvider>

    // </React.StrictMode>
  )
}
